/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_alerts_traffic_panel__no_events__label = /** @type {(inputs: {}) => string} */ () => {
	return `In diesem Gebiet gibt es derzeit keine Meldungen.`
};

const en_alerts_traffic_panel__no_events__label = /** @type {(inputs: {}) => string} */ () => {
	return `There are currently no alerts in the selected zone.`
};

const es_alerts_traffic_panel__no_events__label = /** @type {(inputs: {}) => string} */ () => {
	return `Actualmente no hay alertas en la zona seleccionada.`
};

const fr_alerts_traffic_panel__no_events__label = /** @type {(inputs: {}) => string} */ () => {
	return `Il n’y a actuellement pas d’alertes dans la zone choisie.`
};

const it_alerts_traffic_panel__no_events__label = /** @type {(inputs: {}) => string} */ () => {
	return `Al momento non ci sono segnalazioni nella zona selezionata.`
};

const nl_alerts_traffic_panel__no_events__label = /** @type {(inputs: {}) => string} */ () => {
	return `Er zijn momenteel geen waarschuwingen in de geselecteerde zone.`
};

const pt_alerts_traffic_panel__no_events__label = /** @type {(inputs: {}) => string} */ () => {
	return `Não existem atualmente alertas na zona selecionada.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__no_events__label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.alerts_traffic_panel__no_events__label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("alerts_traffic_panel__no_events__label", locale)
	if (locale === "de") return de_alerts_traffic_panel__no_events__label(inputs)
	if (locale === "en") return en_alerts_traffic_panel__no_events__label(inputs)
	if (locale === "es") return es_alerts_traffic_panel__no_events__label(inputs)
	if (locale === "fr") return fr_alerts_traffic_panel__no_events__label(inputs)
	if (locale === "it") return it_alerts_traffic_panel__no_events__label(inputs)
	if (locale === "nl") return nl_alerts_traffic_panel__no_events__label(inputs)
	return pt_alerts_traffic_panel__no_events__label(inputs)
};